import 'assets/css/404.css'
import logo from 'assets/img/logo-short.svg'
import { useNavigate } from 'react-router-dom'

const NotFound = () => {

  const navigate = useNavigate()

  return (
    <main className="not-found">
      <h1 className='not-found__title'>
        4
        <img src={logo} alt="" />
        4
      </h1>
      <p className='not-found__subtitle'>page not found</p>
      <button className='not-found__back' onClick={() => navigate('dashboard')}>Go home</button>
    </main>
  )
}

export default NotFound;
